<template>
  <div class="container px-3 pt-1 pb-0">
    <template v-if="!gameEnded">
      <div class="scoreboard">
        <div class="row d-md-flex align-items-baseline">
          <h3 class="standing m-0 col-8">
            {{ game.guest.team }} {{ game.guest.score }} : {{ game.home.score }} {{ game.home.team }}
          </h3>
          <div class="inning ms-md-1 col-4 small">Inning: {{ game.inning }} Outs: {{ game.outs }}</div>
        </div>
      </div>
      <div class="field row" v-if="gameView === 'field'">
        <div class="col-md-9" style="position: relative;">
          <div class="field-wrapper" v-if="!isLoading">
            <img alt="bb5-field" class="img-fluid" src="../assets/field.jpg"/>
            <heatmap v-if="showHeatMap" :playerstats="playerStats[atbat().id]"></heatmap>
            <!-- Red Dot for Touch Position -->
            <div class="field_over"
                 @touchstart="registerTouch">
              <div v-if="showTouch" :style="touchDotStyle" class="blue-dot"></div>
              <template v-for="pos in previousBallPositions"
                        :key="pos.inning + '-' + pos.playerId">
                <div  v-if="showTouch && pos.position.x > 0 && pos.position.y > 0"
                      :class="{'green-dot': pos.action === 'H', 'red-dot': pos.action === 'O'}"
                     class="position-absolute green-dot1"
                     :style="{
        left: calculatePosition(pos.position.x, pos.position.y).x + 'px',
        top: calculatePosition(pos.position.x, pos.position.y).y + 'px'
      }">
                </div>
              </template>
              <div v-if="showTouch && playerStats[atbat().id]" class="Ballposition">
                <template v-for="(pos, index) in playerStats[atbat().id]"
                          :key="index + '-' + pos.playerId">
                  <div v-if="pos.position.x > 0 && pos.position.y > 0"
                     :class="{'lightgreen-dot': pos.action === 'H', 'lightred-dot': pos.action === 'O'}"
                     class="position-absolute"
                     :style="{
            left: calculatePosition(pos.position.x, pos.position.y, 5).x + 'px',
            top: calculatePosition(pos.position.x, pos.position.y, 5 ).y + 'px'
          }">
                  </div>
                </template>
              </div>
              <div class="player-position">
                <div
                    class="position-absolute yellow-dot"
                    v-show="getGamePlayerById(atbat().id).curPos === 0"
                    :style="{
        bottom: '4%',
        right: '4%'
      }">{{ getTeamPlayerById(atbat().id).number }}
                </div>
                <div
                    v-if="getPlayerByCurPos(1)"
                    class="position-absolute white-dot"
                    :style="{
        top: '20%',
        right: '11%'
      }">{{ getPlayerByCurPos(1).number }}
                </div>
                <div
                    v-if="getPlayerByCurPos(2)"
                    class="position-absolute white-dot"
                    :style="{
        top: '20%',
        left: '20%'
      }">{{ getPlayerByCurPos(2).number }}
                </div>
                <div
                    v-if="getPlayerByCurPos(3)"
                    class="position-absolute white-dot"
                    :style="{
        bottom: '11%',
        left: '20%'
      }">{{ getPlayerByCurPos(3).number }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ScoreCard v-else/>
      <div class="control row py-2 g-0">
        <div class="col d-flex justify-content-between">
          <button type="button" class="btn btn-dark btn-lg btn-xxl" v-on:click="prevPlay()">Prev</button>
          <button type="button" v-on:click="hit()" class="btn btn-lg btn-xxl btn-success" v-bind:disabled="hasHit">
            H
          </button>
          <button type="button" v-on:click="openSafeModal()" class="btn btn-lg btn-xxl btn-warning"
                  v-bind:disabled="hasHit || !playerOnBase">
            S
          </button>
          <button
              type="button"
              v-on:click="batterOut()"
              class="btn btn-lg btn-xxl btn-danger"
              v-bind:disabled="hasHit"
          >
            X
          </button>
          <button
              type="button"
              v-on:click="defensiveError()"
              class="btn btn-lg btn-xxl btn-danger"
          >
            E
          </button>
          <button type="button" class="btn btn-lg btn-dark btn-xxl" v-on:click="calcOuts()"
                  v-bind:disabled="!hasHit">Next
          </button>
        </div>
      </div>
      <div class="teams row mb-3" v-if="!isLoading">
        <div v-for="team of sortedTeams" class="team col-6 btn-group-vertical justify-content-start" role="group"
             :key="team.id">
          <template v-for="(player, index) in sortedPlayers(team).slice(0, 5)" :key="index" class="">
            <div
                v-if="!isPlayerInGame(player.id, team)"
                class="btn-group" role="group"
            >
              <button
                  :id="'btnGroupDrop' + index + 1"
                  type="button"
                  class="btn dropdown-toggle btn-bb5-black overflow-hidden btn-md-xl"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
              >
                <span class="overflow-hidden">{{
                    usePlayerNames ? shortName(player.name) : player.number
                  }}  ({{ player.gender }})</span>
              </button>
            </div>
            <div
                v-if="!isPlayerInGame(player.id, team)"
                class="btn-group" role="group"
            >
              <button
                  :id="'btnGroupDrop' + index + 1"
                  type="button"
                  class="btn dropdown-toggle btn-bb5-black overflow-hidden btn-md-xl"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
              >
                <span class="overflow-hidden">{{
                    usePlayerNames ? shortName(player.name) : player.number
                  }}  ({{ player.gender }})</span>
              </button>
              <ul class="dropdown-menu" :aria-labelledby="'btnGroupDrop' + index">
                <li class="">
                  <div class="dropdown-header">1{{ player.name }} #{{ player.number }} ({{ player.gender }})</div>
                </li>
                <li v-for="gamerPlayer in filteredPlayers(team)" :key="gamerPlayer.id">
                  <div
                      v-if="playerNotHitJet(gamerPlayer)"
                      class="dropdown-item"
                      v-on:click="substitutWith(player.id, gamerPlayer.id, true)"
                      href="#"
                  >
                    Substitute with {{ getTeamPlayerById(gamerPlayer.id).name }}
                  </div>
                  <div
                      v-else-if="changeLineUp"
                      class="dropdown-item"
                      v-on:click="changeLineUpPosition(player.id, gamerPlayer.lineUpPosition, team.name)"
                      href="#"
                  >
                      Lineup Position {{ gamerPlayer.lineUpPosition }}
                  </div>
                </li>
              </ul>
            </div>
            <div
                v-else-if="playerPosition(player.id) > 0"
                class="btn-group" role="group"
            >
              <button
                  :id="'btnGroupDrop' + index"
                  type="button"
                  class="btn dropdown-toggle btn-outline-bb5 btn-md-xl"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
              >
                {{ usePlayerNames ? shortName(player.name) : player.number }} ({{ player.gender }}) <span
                  class="text-secondary">{{
                  playerPosition(player.id) > 0 ? playerPosition(player.id) + '. Base' : ''
                }}</span>
              </button>
              <ul class="dropdown-menu" :aria-labelledby="'btnGroupDrop' + index">
                <li class="">
                  <div class="dropdown-header">{{ player.name }} #{{ player.number }} ({{ player.gender }})</div>
                </li>
                <li>
                  <div class="dropdown-item" v-on:click="ruledOut(player.id)" href="#">
                    Out
                  </div>
                </li>
                <li v-if="!isHigherPositionOccupied(player.id)">
                  <div
                      class="dropdown-item"
                      v-on:click="scored(player.id)"
                      href="#"
                  >
                    Scored
                  </div>
                </li>
                <li
                    v-if="
                playerPosition(player.id) < 3 &&
                !isNextPositionOccupied(player.id)
              "
                >
                  <div
                      class="dropdown-item"
                      v-on:click="extraBase(player.id)"
                      href="#"
                  >
                    extra Base
                  </div>
                </li>
              </ul>
            </div>
            <div
                v-else
                class="btn-group" role="group"
            >
              <button
                  type="button"
                  class="btn btn-md-xl"
                  :class="{
                    'btn-bb5-yellow': offenceTeam === team.teamSide && index + 1 === score.inning[0]?.play[0]?.lineUpPosition[team.teamSide],
                    'btn-outline-bb5': !(offenceTeam === team.teamSide && index + 1 === score.inning[0]?.play[0]?.lineUpPosition[team.teamSide]),
                    'dropdown-toggle': !playerNotHitJet(player) && changeLineUp
                  }"
                  data-bs-toggle="dropdown"
              >
                {{ usePlayerNames ? shortName(player.name) : player.number }} ({{ player.gender }}) <span
                  class="text-secondary">{{
                  playerPosition(player.id) > 0 ? playerPosition(player.id) + '. Base' : ''
                }}</span>
              </button>
              <ul class="dropdown-menu" :aria-labelledby="'btnGroupDrop' + index"
                  v-if="!playerNotHitJet(player)">
                <li class="d-block 1">
                  <div class="dropdown-header">{{ player.name }} #{{ player.number }} ({{ player.gender }})</div>
                </li>
                <template v-for="gamerPlayer in filteredPlayers(team)" :key="gamerPlayer.id">
                  <li v-if="player.id !== gamerPlayer.id && !playerNotHitJet(gamerPlayer)">
                    <div
                        v-if="changeLineUp"
                        class="dropdown-item"
                        v-on:click="changeLineUpPosition(player.id, gamerPlayer.lineUpPosition, team.name)"
                        href="#"
                    >
                      Lineup Position {{ gamerPlayer.lineUpPosition }}
                    </div>
                  </li>
                </template>
              </ul>
            </div>
          </template>
          <div
              v-if="sortedPlayers(team).length > 5"
              class="btn-group" role="group"
          >
            <button
                :id="'btnGroupDropSub'"
                type="button"
                class="btn dropdown-toggle btn-bb5-black overflow-hidden btn-md-xl"
                data-bs-toggle="dropdown"
                aria-expanded="false"
            >
              <span class="overflow-hidden">{{ $t('teamSetup.substitutes') }}</span>
            </button>

            <ul class="dropdown-menu" aria-labelledby="btnGroupDropSub">
              <li v-for="(player, index) in sortedPlayers(team).slice(5)" :key="index" class="substitutes d-block">
                <span class="dropdown-item overflow-hidden text-center"
                      v-on:click="changeLineUpPosModal(player, sortedPlayers(team).slice(0, 5, team.name))">{{
                    usePlayerNames ? shortName(player.name) : player.number
                  }}  ({{ player.gender }})</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <full-screen-modal
          :isOpen="isModalOpen"
          :componentToRender="currentComponent"
          :componentProps="componentProps"
          @close="closeModal"
          @substitute="substitutWith"
          @runnerout="safe"
          @player-selected="assignPinchRunner"
          @prevplay="loadPrevPlay"
      />
    </template>
    <div class="admininfo" v-if="admin">
    </div>
    <Result
        v-if="gameEnded"
        :homeScore="game.home.score"
        :guestScore="game.guest.score"
        @restart-game="restartGame"
    />
    <!-- Modal-Komponente für die Spielerauswahl -->
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import Result from "./Result.vue"; // Import the Result component
import PlayerSelectionModal from './Modal/PlayerSelectionModal.vue'; // Importiere die Modal-Komponente
import apiService from '../services/apiService';
import FullScreenModal from './FullScreenModal.vue';
import Substitut from "./Modal/Substitut.vue";
import ScoreCard from './Scoreing/ScoreCard.vue';
import { saveGame, saveScore } from '@/services/indexedDB';

import rules from '../mixins/Rules';
import scoreing from '../mixins/Scoreing';
import ballPosition from "@/mixins/BallPosition";
import RunnerOut from "@/components/Modal/RunnerOut.vue";
import core from "@/mixins/Core";
import localStorageService from "@/services/localStorageService";
import Heatmap from "@/components/Heatmap.vue";
import PlayHistoryModal from "./Modal/PlayHistoryModal.vue";
export default {
  name: "Scoreing",
  components: {
    Heatmap,
    Result,
    FullScreenModal,
    ScoreCard
  },
  props: {
    msg: String,
  },
  data() {
    return {
      isLoading: true,
      inning: 1,
      regularInnings: 5,
      maxOuts: 3,
      gameEnded: false, // Track if the game has ended
      logArr: [],
      posArr: [],
      playerStats: {},
      availablePinchRunners: [],
      modalMsg: '',
      touchPosition: { x: 0, y: 0 },  // Store touch position
      showTouch: false,  // Boolean to control red dot visibility
      showHeatMap: false,  // Boolean to control red dot visibility
      changeLineUp: false,
      admin: true,
      hasHit: false,
      isSafe: false,
      isModalOpen: false,
      currentComponent: null,
      componentProps: {},
      playerOnBase: false,
      usePlayerNames: false,
      specialCaseBatter: null,
      view: true,
      outAction: '',
      playIdAction: null,
    };
  },
  mixins: [core, rules, ballPosition, scoreing],
  async created() {
    if(this.checkSavedGames()) {
      const gameId = localStorage.getItem('currentgame');
      // const gameExists = await this.loadScore(gameId)
      const gameExists = await this.continueGame(gameId);
      if(!gameExists) {
        this.saveStatistic()
        const action = {
          action: "start",
          offenceTeam: "guest",
          playerId: this.game[this.offenceTeam].players[0].id,
          team: 'guest',
          inning: this.game.inning,
          lineUpPosition: 1,
          positions: this.game[this.offenceTeam].players
        }
        await this.saveAction(action);
      } else {
        this.isGameOver()
      }
    } else {
      this.saveStatistic()
    }
    this.isPlayerOnBase()
    this.loadAllPlayersStats();
    this.showTouch = localStorageService.get('showBallPos') === 'false' ? false : true;
    this.showHeatMap = localStorageService.get('showHeatMap') === 'false' ? false : true;
    this.usePlayerNames = localStorageService.get('useNames') === 'false' ? false : true;
    this.changeLineUp = localStorageService.get('changeLineupInGame') === 'false' ? false : true;

    this.isLoading = false;
  },
  computed: {
    ...mapState(["teams", "game", "gameSettings", "score", "gameView"]),
    ...mapGetters(['getPlayerById', 'gameStats', 'findPlayerInGame', 'getTeamByPlayer', 'findPrevPlayerInScore']),
    offenceTeam() {
      return this.game.offenceTeam ? this.game.offenceTeam : 'guest';
    },
    offenceTeams() {
      return this.teams.find(team => team.teamSide === this.game.offenceTeam);
    },
    sortedTeams() {
      // Sortiere die Teams basierend auf teamSide: "guest" zuerst, dann "home"
      return this.teams.slice().sort((a, b) => {
        if (a.teamSide === "guest" && b.teamSide === "home") return -1;
        if (a.teamSide === "home" && b.teamSide === "guest") return 1;
        return 0; // Falls beide gleich sind, bleibt die Reihenfolge erhalten
      });
    },
  },
  methods: {
    ...mapActions(['setGame', 'setGameStats', 'checkSavedGames', 'continueGame' ,'setScore', 'resetPlay']),
    atbat() {
      const lineUpPosition = this.score.inning[0]?.play[0]?.lineUpPosition[this.offenceTeam] ? this.score.inning[0].play[0].lineUpPosition[this.offenceTeam] : 1
      const playerAtBat = this.game[this.offenceTeam].players.find(
          (player) => player.lineUpPosition === lineUpPosition
      );
      // console.log('atbat', this.offenceTeam, this.game[this.offenceTeam].lineUpPosition, playerAtBat)
      return playerAtBat
    },
    hit() {
      this.incrementAllCurPos();
      this.incrementCurPos();
      const action = {
        action: "hit",
        playerId: this.atbat().id,
        team: this.offenceTeam,
        offenceTeam: this.offenceTeam,
        inning: this.game.inning,
        lineUpPosition: this.score.inning[0].play[0].lineUpPosition[this.offenceTeam] === 5 ? 1 : this.score.inning[0].play[0].lineUpPosition[this.offenceTeam] + 1,
        positions: this.game[this.offenceTeam].players
      }
      this.saveAction(action);
      this.lineUpPositionUp();
      this.saveBallPosition("H"); // Save position with "H" for hit
      this.log(
          this.atbat().name +
          " (" +
          this.game[this.offenceTeam].team +
          ") is safe at first base."
      );
      this.hasHit = true
    },
    safe(playerId) {
      const playerOut = this.game[this.offenceTeam].players.find(
          (player) => player.id === playerId
      );
      playerOut.curPos = 0;
      this.game.outs++;
      this.incrementAllCurPos();
      this.incrementCurPos();
      const actionSafe = {
        action: "safe",
        playerId: this.atbat().id,
        team: this.offenceTeam,
        offenceTeam: this.offenceTeam,
        inning: this.game.inning,
        lineUpPosition: this.score.inning[0].play[0].lineUpPosition[this.offenceTeam] === 5 ? 1 : this.score.inning[0].play[0].lineUpPosition[this.offenceTeam] + 1,
        positions: this.game[this.offenceTeam].players
      }
      this.saveAction(actionSafe);
      if(this.game.outs < this.maxOuts) {
        const actionOut = {
          action: "out",
          playerId: playerId,
          team: this.offenceTeam,
          offenceTeam: this.offenceTeam,
          inning: this.game.inning,
          lineUpPosition: this.score.inning[0].play[0].lineUpPosition[this.offenceTeam],
          positions: this.game[this.offenceTeam].players
        }
        this.saveAction(actionOut);
        this.lineUpPositionUp();
      } else {
        this.outAction = 'out'
      }

      this.playerIdAction = playerId
      this.saveBallPosition("S"); // Save position with "H" for hit
      this.log(
          this.atbat().name +
          " (" +
          this.game[this.offenceTeam].team +
          ") is safe at first base."
      );
      this.hasHit = true
      this.isSafe = true
    },
    batterOut() {
      this.game.outs++;
      if(this.game.outs < this.maxOuts) {
        const action = {
          action: "batterout",
          playerId: this.atbat().id,
          team: this.offenceTeam,
          offenceTeam: this.offenceTeam,
          inning: this.game.inning,
          lineUpPosition: this.score.inning[0].play[0].lineUpPosition[this.offenceTeam] === 5 ? 1 : this.score.inning[0].play[0].lineUpPosition[this.offenceTeam] + 1,
          positions: this.game[this.offenceTeam].players
        }
        this.saveAction(action);
        this.lineUpPositionUp();
      } else {
        this.outAction = 'batterout'
      }
      this.log(
        this.getTeamPlayerById(this.atbat().id).name +
          " (" +
          this.game[this.offenceTeam].team +
          ") is out (" +
          (this.game.outs + 1) +
          "/" +
          this.maxOuts +
          ")"
      );
      this.saveBallPosition("O");
      this.hasHit = true
    },
    defensiveError() {
      this.incrementAllCurPos();
      const action = {
        action: "error",
        team: this.offenceTeam === "home" ? "guest" : "home",
        offenceTeam: this.offenceTeam,
        playerId: null,
        inning: this.game.inning,
        lineUpPosition: this.game[this.offenceTeam].lineUpPosition,
        positions: this.game[this.offenceTeam].players
      }
      this.saveAction(action);
      this.log(
          "Denfensive error every player move up one base (" +
          this.game[this.offenceTeam].team +
          ")"
      );
    },
    lineUpPositionUp() {
      this.isPlayerOnBase()
      if (this.game[this.offenceTeam].lineUpPosition === 5) {
        this.game[this.offenceTeam].lineUpPosition = 1;
      } else {
        this.game[this.offenceTeam].lineUpPosition++;
      }
    },
    lineUpPositionUpNew() {
      if (this.score.lineUpPosition[this.offenceTeam] === 5) {
        this.score.lineUpPosition[this.offenceTeam] = 1;
      } else {
        this.score.lineUpPosition[this.offenceTeam]++;
      }
    },
    out(playerId) {
      const gamePlayer = this.game[this.offenceTeam].players.find(
          (player) => player.id === playerId
      );
      gamePlayer.curPos = 0;
      this.game.outs++;
      if(this.game.outs < this.maxOuts) {
        const action = {
          action: "out",
          playerId: playerId,
          team: this.offenceTeam,
          offenceTeam: this.offenceTeam,
          inning: this.game.inning,
          lineUpPosition: this.score.inning[0].play[0].lineUpPosition[this.offenceTeam],
          positions: this.game[this.offenceTeam].players
        }
        this.saveAction(action);
      } else {
        this.outAction = 'out'
      }
      this.log(
          this.getTeamPlayerById(playerId).name +
          " (" +
          this.game[this.offenceTeam].team +
          ") is out (" +
          (this.game.outs + 1) +
          "/" +
          this.maxOuts +
          ")"
      );
    },
    ruledOut (playerId) {
      this.out(playerId)
    },
    scored(playerId) {
      const gamePlayer = this.game[this.offenceTeam].players.find(
          (player) => player.id === playerId
      );
      gamePlayer.curPos = 0;
      this.game[this.offenceTeam].score++;
      const action = {
        action: "scored",
        playerId: playerId,
        team: this.offenceTeam,
        offenceTeam: this.offenceTeam,
        inning: this.game.inning,
        lineUpPosition: this.score.inning[0].play[0].lineUpPosition[this.offenceTeam],
        positions: this.game[this.offenceTeam].players
      }
      this.saveAction(action);
      this.log(
          this.getTeamPlayerById(playerId).name +
          " (" +
          this.game[this.offenceTeam].team +
          ") scored (" +
          this.game.home.score +
          " : " +
          this.game.guest.score +
          ")"
      );
    },
    extraBase(playerId) {
      const gamePlayer = this.game[this.offenceTeam].players.find(
          (player) => player.id === playerId
      );
      gamePlayer.curPos++;
      const action = {
        action: "position",
        playerId: playerId,
        team: this.offenceTeam,
        offenceTeam: this.offenceTeam,
        inning: this.game.inning,
        lineUpPosition: this.game[this.offenceTeam].lineUpPosition,
        positions: this.game[this.offenceTeam].players
      }
      this.saveAction(action);
      this.log(
          this.getTeamPlayerById(playerId).name +
          " (" +
          this.game[this.offenceTeam].team +
          ") advanced to " +
          gamePlayer.curPos +
          " base."
      );
    },
    calcOuts() {
      this.lineUpPositionUpNew();
      this.saveStatistic()
      this.handleBasesLoadedSpecialCase();
      const team = this.offenceTeam
      const playerId = this.playerIdAction ? this.playerIdAction : this.atbat().id
      if (this.game.outs === this.maxOuts) {
        if (!this.isGameOver()) {
          if (this.offenceTeam === "home") {
            this.log(`End of bottom ${this.game.inning} inning`);
            this.game.inning++;
          } else {
            this.log(`End of top ${this.game.inning} inning`);
          }
          // Reset curPos of all players on the current offense team before switching teams
          this.resetPlayerPositions(this.offenceTeam);
          this.lineUpPositionUp();
          this.game.outs = 0;
          this.game.offenceTeam = this.offenceTeam === "home" ? "guest" : "home";
          const action = {
            action: this.outAction,
            playerId: playerId,
            team: team,
            offenceTeam: team,
            inning: this.offenceTeam === "home" ? this.game.inning : this.game.inning - 1,
            lineUpPosition: this.score.inning[0].play[0].lineUpPosition[team] === 5 ? 1 : this.score.inning[0].play[0].lineUpPosition[team],
            positions: this.game[this.offenceTeam].players
          }
          this.saveAction(action);
          
          const actionInning = {
            action: this.offenceTeam === "home" ? "bottom" : "top",
            playerId: this.atbat().id,
            team: this.offenceTeam,
            offenceTeam: this.offenceTeam,
            inning: this.game.inning,
            lineUpPosition: this.score.inning[0].play[0].lineUpPosition[this.offenceTeam],
            positions: this.game[this.offenceTeam].players
          }
          this.saveAction(actionInning);

          this.playerIdAction = null
          // this.game.offenceTeam = this.game[this.offenceTeam].team
          // Check if extra innings rule applies
          if (this.game.inning > this.regularInnings) {
            this.placeRunnersForExtraInnings(); // Place runners for extra innings
          }
        } else {
          const action = {
            action: "end",
            playerId: playerId,
            team: team,
            offenceTeam: team,
            inning: this.game.inning,
            lineUpPosition: this.score.inning[0].play[0].lineUpPosition[team] === 5 ? 1 : this.score.inning[0].play[0].lineUpPosition[team],
            positions: this.game[this.offenceTeam].players
          }
          this.saveAction(action);
        }
      }
    },
    incrementCurPos() {
      const player = this.game[this.offenceTeam].players.find(
          (player) => player.lineUpPosition === this.game[this.offenceTeam].lineUpPosition
      );
      player.curPos++;
    },
    incrementAllCurPos() {
      const players = this.game[this.offenceTeam].players;
      const playersByCurPos = players
          .filter((player) => player.curPos > 0)
          .slice().sort((a, b) => b.curPos - a.curPos);
      playersByCurPos.forEach((player) => {
        if (player.curPos >= 1) {
          if(!this.isPrevPositionOccupied(player.id)) {
            return;
          }
          player.curPos++;
          if (player.curPos === 4) {
            this.log(
                this.getTeamPlayerById(player.id).name +
                " (" +
                this.game[this.offenceTeam].team +
                ") scored."
            );
            player.curPos = 0;
            this.scored(player.id);
          } else {
            this.log(
                this.getTeamPlayerById(player.id).name +
                " (" +
                this.game[this.offenceTeam].team +
                ") advanced to " +
                player.curPos +
                " base."
            );
          }
        } else {
          console.warn('incrementAllCurPos not found: ', player)
        }
      });
    },
    resetPlayerPositions(offenseTeam) {
      const players = this.game[offenseTeam].players;
      players.forEach(player => {
        player.curPos = 0;  // Reset each player's current position
      });
    },
    playerPosition(playerId) {
      const gamePlayer = this.game[this.offenceTeam].players.find(
          (player) => player.id === playerId
      );
      return gamePlayer ? gamePlayer.curPos : 0;
    },
    placeRunnersForExtraInnings() {
      const inningOffset = this.game.inning - this.regularInnings;

      // Determine the number of runners to place based on the inning
      if (inningOffset === 1) {
        // First extra inning: Place one runner on 1st base
        this.placePreviousPlayerOnBase(1);
      } else if (inningOffset === 2) {
        // Second extra inning: Place runners on 1st and 2nd base
        this.placePreviousPlayerOnBase(2);
      } else if (inningOffset >= 3) {
        // Third extra inning and beyond: Place runners on 1st, 2nd, and 3rd base
        this.placePreviousPlayerOnBase(3);
      }
    },
    placePreviousPlayerOnBase(numRunners) {
      const currentLineupPos = this.score.lineUpPosition[this.offenceTeam];
      for (let i = numRunners; i >= 1; i--) {
        const previousLineupPos = currentLineupPos - i <= 0 ? 4 - (currentLineupPos - i) : currentLineupPos - i;
        const previousPlayer = this.game[this.offenceTeam].players[previousLineupPos];
        // Place them on base according to the base number
        previousPlayer.curPos = i; 

        const action = {
          action: "runner",
          playerId: previousPlayer.id,
          team: this.offenceTeam,
          offenceTeam: this.offenceTeam,
          positions: this.game[this.offenceTeam].players,
          lineUpPosition: currentLineupPos,
          inning: this.game.inning
        }
        this.saveAction(action);
        this.log(
            `${previousPlayer.name} (${this.game[this.offenceTeam].team}) is placed on base ${i}.`
        );
      }
    },
    isNextPositionOccupied(playerId) {
      const gamePlayer = this.game[this.offenceTeam].players.find(
          (player) => player.id === playerId
      );
      const nextPosition = gamePlayer.curPos + 1;
      return this.game[this.offenceTeam].players.some(
          (player) => player.curPos === nextPosition
      );
    },
    isPrevPositionOccupied(playerId) {
      const gamePlayer = this.game[this.offenceTeam].players.find(
          (player) => player.id === playerId
      );
      const prevPosition = gamePlayer.curPos - 1;
      if (prevPosition === 0) {
        return true;
      }
      return this.game[this.offenceTeam].players.some(
          (player) => player.curPos === prevPosition
      );
    },
    getPlayerByCurPos(base) {
      const player = this.game[this.offenceTeam].players.find(
          (player) => player.curPos === base
      );
      return player ? this.getTeamPlayerById(player.id) : ''
    },
    isHigherPositionOccupied(playerId) {
      const gamePlayer = this.game[this.offenceTeam].players.find(
          (player) => player.id === playerId
      );
      const currentPos = gamePlayer.curPos;
      return this.game[this.offenceTeam].players.some(
          (player) => player.curPos > currentPos
      );
    },
    handleBasesLoadedSpecialCase() {
      // Check if bases are loaded and there are two outs
      if (this.isBasesLoaded() && this.game.outs === 2) {
        const currentTeam = this.game[this.offenceTeam];
        const players = currentTeam.players;

        // Find the player on 3rd base
        const playerOn3rd = players.find(player => player.curPos === 3);
        this.specialCaseBatter = playerOn3rd
        // Ensure the player on 3rd is the next batter according to the lineup
        // console.log(playerOn3rd.lineUpPosition, this.game[this.offenceTeam].lineUpPosition)
        if (playerOn3rd && this.game[this.offenceTeam].lineUpPosition === playerOn3rd.lineUpPosition) {
          this.log(
              "Special Case: Bases loaded with 2 outs, next batter is on 3rd base."
          );
          playerOn3rd.curPos = 0; // Reset the player on 3rd base to home
          // Advance all players one base
          this.advanceAllBases();

          // Pinch runner is placed at 1st base
          this.placePinchRunner();
          // Log the pinch runner assignment
          this.logPinchRunner();
        }
      }
    },
    isBasesLoaded() {
      const currentTeam = this.game[this.offenceTeam].players;
      const basesOccupied = currentTeam.filter(player => player.curPos > 0);
      return basesOccupied.length === 3; // Bases loaded if 3 players are on bases
    },
    advanceAllBases() {
      const currentTeam = this.game[this.offenceTeam].players;
      // Advance each player
      currentTeam.forEach(player => {
        if (player.curPos > 0) {
          player.curPos++;

          // If a player reaches home (curPos 4), they score
          if (player.curPos === 4) {
            player.curPos = 0;
          }
        }
      });
      // Reset the player on 3rd base to be the next batter
      this.log(`${this.atbat().name} is now the batter.`);
    },
    placePinchRunner() {
      const currentTeam = this.game[this.offenceTeam]
      // Überprüfen, ob die Teamgröße 5 ist
      if (currentTeam.players.length === 5) {
        // Den Spieler finden, der aktuell am Schlag ist (an curPos = 0)
        const playersWithCurPosZero = currentTeam.players.filter(player => player.curPos === 0);
        // Den Spieler aus der Lineup holen
        const playerForPinchRunner = playersWithCurPosZero[playersWithCurPosZero.length - 1];
        // Setze den Spieler auf curPos = 1
        playerForPinchRunner.curPos = 1;

        const action = {
            action: "special",
            playerId: this.specialCaseBatter.id,
            team: this.offenceTeam,
            offenceTeam: this.offenceTeam,
            positions: this.game[this.offenceTeam].players,
            lineUpPosition: this.game[this.offenceTeam].lineUpPosition,
            inning: this.game.inning
          }
          this.saveAction(action);
          this.specialCaseBatter = null
        // Logge die Aktion
        this.log(`${playerForPinchRunner.name} wurde als Pinch Runner auf 1st Base (curPos = 1) gesetzt.`);
      } else {
        this.openPlayerSelectionModal()
        this.log('Die Teamgröße ist nicht 5, daher wird kein Pinch Runner gesetzt.');
      }
    },
    isPlayerOnBase() {
      const playerFound = this.game[this.offenceTeam].players.filter(
          (player) => player.curPos > 0
      );
      this.playerOnBase = playerFound.length > 0
      return playerFound
    },
    openPlayerSelectionModal() {
      // Check if gender limit enforcement is enabled
      const currentTeamId = this.game[this.offenceTeam].team
      const currenTeam = this.teams.find(team => team.name === currentTeamId);
      const benchPlayers = this.game[this.offenceTeam].players.filter(player => player.lineUpPosition > 5);
      if (this.gameSettings.enforceGenderLimit ) {
        // Get the current batter at bat
        const currentBatter = this.game[this.offenceTeam].players[this.game[this.offenceTeam].lineUpPosition];

        // Check if the current batter is male or female
        const currentBatterGender = this.getPlayerById(currentBatter.id).gender

        // Filter the lineup players to find those currently in the game and in the top 5 lineup positions
        const topLineUpPlayers = this.game[this.offenceTeam].players.filter(player => player.lineUpPosition <= 5);

        // Count the number of players of the same gender as the current batter
        const genderCount = topLineUpPlayers.filter(player => {
          const playerGender = this.getPlayerById(player.id).gender;
          return playerGender === currentBatterGender;
        }).length;

        // Assuming the gender limit is 2
        if (genderCount >= 2) {
          this.modalMsg = `Pinchrunner should be (${currentBatterGender}) to keep gender balance.`;
        }
      }
      // Überprüfe, ob die Anzahl der Spieler nicht gleich 5 ist und öffne das Modal
      // Filtere alle Spieler aus this.team, die mit den Bankspielern (benchPlayers) übereinstimmen
      this.availablePinchRunners = currenTeam.players.filter(player =>
          benchPlayers.some(benchPlayer => benchPlayer.id === player.id)
      );
      // Falls es verfügbare Pinch Runner gibt, öffne das Modal
      if (this.availablePinchRunners.length > 0) {
        let probs = {
          'availablePlayers': this.availablePinchRunners,
          'modalMsg': this.modalMsg,
        }
        this.openModal('SpecialCase', probs)
      } else {
        this.log('Keine Pinch Runner verfügbar.');
      }
    },
    openSafeModal() {
      this.openModal('RunnerOut', {runners: this.isPlayerOnBase()})
    },
    assignPinchRunner(benchPlayer) {
      const player = this.game[this.offenceTeam].players.find(player => player.id === benchPlayer.id);
      // Der ausgewählte Spieler wird hier als Pinch Runner gesetzt
      player.curPos = 1;

      const action = {
        action: "special",
        playerId: this.specialCaseBatter.id,
        team: this.offenceTeam,
        offenceTeam: this.offenceTeam,
        positions: this.game[this.offenceTeam].players,
        lineUpPosition: this.game[this.offenceTeam].lineUpPosition,
        inning: this.game.inning
      }
      this.saveAction(action);
      this.specialCaseBatter = null
      this.log(`${player.name} wurde als Pinch Runner ausgewählt.`);
    },
    logPinchRunner() {
      this.log("Pinch runner has been placed at 1st base to respect the batting order.");
    },
    sortedPlayers(team) {
      const teamPlayers = team.players;
      const gameTeam =
          this.game.home.team === team.name ? this.game.home : this.game.guest;
      return teamPlayers.slice().sort((a, b) => {
        const aPlayer = gameTeam.players.find((player) => player.id === a.id);
        const bPlayer = gameTeam.players.find((player) => player.id === b.id);
        const aLineUpPosition = aPlayer ? aPlayer.lineUpPosition : Infinity;
        const bLineUpPosition = bPlayer ? bPlayer.lineUpPosition : Infinity;

        if (aLineUpPosition !== bLineUpPosition) {
          return aLineUpPosition - bLineUpPosition;
        }

        return teamPlayers.indexOf(a) - teamPlayers.indexOf(b);
      });
    },
    filteredPlayers(team) {
      return this.game[team.teamSide].players.filter(player => player.lineUpPosition <= 5);
    },
    isPlayerInGame(playerId, team) {
      const activePlayers = this.game[team.teamSide].players;
      return activePlayers.some((player) => player.id === playerId && player.lineUpPosition <= 5);
    },
    changeLineUpPosition(playerId, newLineUpPosition, teamName) {
      // Step 1: Determine the correct team in the game object
      const team = (teamName === this.game.homeTeam) ? this.game.home : this.game.guest;

      // Step 2: Find the player by id within the team’s player list
      const playerIndex = team.players.findIndex(p => p.id === playerId);

      if (playerIndex === -1) {
        console.warn(`Player with ID ${playerId} not found in team ${teamName}`);
        return;
      }

      // Save the original lineUpPosition of the targeted player
      const originalPosition = team.players[playerIndex].lineUpPosition;

      // Step 4: Find the player with the lineUpPosition just before the new position
      const precedingPlayerIndex = team.players.findIndex(p => p.lineUpPosition === newLineUpPosition);

      // Step 3: Update the specified player's lineUpPosition to the new position
      team.players[playerIndex].lineUpPosition = newLineUpPosition;

      // If a preceding player is found, update their position to the original position
      if (precedingPlayerIndex !== -1) {
        team.players[precedingPlayerIndex].lineUpPosition = originalPosition;
      }
      // Step 5: Sort players by lineUpPosition to ensure the correct order
      team.players.sort((a, b) => a.lineUpPosition - b.lineUpPosition);
    },
    substitutWith(playerId, gamePlayerId, sub) {
      const substitutePlayer =
            this.game.home.players.find((player) => player.id === playerId) ||
            this.game.guest.players.find((player) => player.id === playerId);
      const subPlayerLineUpPos = substitutePlayer.lineUpPosition;
      const currentPlayer =
            this.game.home.players.find((player) => player.id === gamePlayerId) ||
            this.game.guest.players.find((player) => player.id === gamePlayerId);
      const curPlayerLineUpPos = currentPlayer.lineUpPosition;
      const team = this.getTeamByPlayer(substitutePlayer.id);

      if (substitutePlayer && currentPlayer) {
        const originalGamePlayer =
            this.game.home.players.find((player) => player.substitutWithId === substitutePlayer.id) ||
            this.game.guest.players.find((player) => player.substitutWithId === substitutePlayer.id);
            
        if(this.gameSettings.enforceGenderLimit){
          if (currentPlayer.gender !== substitutePlayer.gender) {
            alert(this.$t('substitution.sameGenderOnly', { name: substitutePlayer.name }));
            return;
          }
        }
        if (originalGamePlayer && originalGamePlayer.id !== substitutePlayer.id) {
          alert(
              `${substitutePlayer.name} can only reenter for ${this.getTeamPlayerById(
                substitutePlayer.id
              ).name}.`
          );
          return;
        }
        if (sub === true)
        {
          this.log(
              `${substitutePlayer.name} entered for ${this.getTeamPlayerById(
                currentPlayer.id
              ).name}.`
          );
          currentPlayer.substitutWithId = substitutePlayer.id;
        }
        currentPlayer.lineUpPosition = subPlayerLineUpPos;
        substitutePlayer.lineUpPosition = curPlayerLineUpPos;
        this.game[team].players.sort((a, b) => a.lineUpPosition - b.lineUpPosition);

        const action = {
          action: "substitute",
          playerId: playerId,
          team: team,
          offenceTeam: this.offenceTeam,
          positions: this.game[this.getTeamByPlayer(substitutePlayer.id)].players,
          lineUpPosition: this.game[this.offenceTeam].lineUpPosition,
          inning: this.game.inning
        }
        this.saveAction(action);
      }
    },
    playerNotHitJet(player) {
      return this.posArr.find(play => play.playerId === player.id);
    },
    determineTeamRole(team) {
      return this.$store.getters.getIsHomeOrGuestTeam(team.name);
    },
    async previousBallPositionsStats() {
      // Get the current batter's ID
      const currentBatter = this.atbat();
      return apiService.get('playerstats/' + currentBatter.id);
      // Filter positions for the current batter from previous innings
      // return this.posArr.filter(pos => pos.playerId === currentBatter.id && pos.position.x !== "0.0000" && pos.position.y !== "0.0000" && this.admin);
    },
    toggleView() {
      this.$store.commit('TOGGLE_VIEW');
    },
    log(text) {
      this.logArr.unshift(text);
    },
    prevPlay () {
      this.openModal('PlayHistory')
    },
    loadPrevPlay(data) {
      if(this.score.inning.length > 0) { // Ensure there are at least two entries
        const [inning, sliceStart] = data.split('-').map(Number);
        const inningData = this.score.inning.find(i => i.inning === inning);
        this.score.inning = this.score.inning.filter(i => i.inning <= inning);
        const plays = inningData?.play?.slice(sliceStart) ?? [];

        // Füge sie ins Ziel-Inning wieder ein
        const targetInning = this.score.inning.find(i => i.inning === inning);
        if (targetInning) {
          targetInning.play = plays;
        }
        // console.log('inningData', inningData, plays, this.score.inning)
        const resetScore = this.resetPlay(this.score)

        saveScore(resetScore);   
      }

    },
    async saveStatistic (){
      this.hasHit = false
      const previousAction = this.posArr.slice(-1)[0];  // Last entry in the position array
      const currentPlay = JSON.parse(JSON.stringify(this.game));
      if (previousAction) {
        const previousPlayer = this.getTeamPlayerById(previousAction.playerId);  // Assuming playerId is stored in the action data
        // Prepare play statistics
        const playStats = {
          game: currentPlay,  // The game state
          player: previousPlayer,  // Previous batter (not the current atbat)
          teams: this.teams,
          position: previousAction.position,  // Position of the previous batter's play
          action: previousAction.action  // Action they took (H for hit, O for out, etc.)
        };
        const playStatsApi = {
          player: previousPlayer.id,  // Previous batter (not the current atbat)
          position: previousAction.position,  // Position of the previous batter's play
          action: previousAction.action  // Action they took (H for hit, O for out, etc.)
        };
        // console.log(playStatsApi);
        // apiService.post('playerstats', playStatsApi)
        this.postData('playerstats', playStatsApi)
        apiService.post('gamestats', this.game)
        // this.postData('gamestats', this.game)
        this.gameStats.push(playStats)
      } else {
        const playStats = {
          game: currentPlay,  // The game state
          player: this.atbat(),  // Previous batter (not the current atbat)
          teams: this.teams,
          position: {},  // Position of the previous batter's play
          action: ''  // Action they took (H for hit, O for out, etc.)
        };
        this.setGameStats(playStats)
      }
      await saveGame({ id: this.game.id, game: this.gameStats });
    },
    async loadAllPlayersStats() {
      try {
        // Get all teams and their players from the Vuex store using the teams getter
        const teams = this.$store.getters.teams;

        // Extract players from both teams
        const allPlayers = teams.flatMap(team => team.players);

        // Loop through each player and fetch their stats
        for (const player of allPlayers) {
          const playerId = player.id;  // Assuming player has an `id` property
          const response = await apiService.get('playerstats/' + playerId);

          // Store the stats in `playerStats` indexed by playerId
          if(response.status === 200 && !response.data.error) {
            this.playerStats[playerId] = response.data;
          }
        }
      } catch (error) {
        console.error('Error loading player stats:', error);
      }
    },
    isGameOver() {
      if(this.score.status === true){
        // console.log(this.score.status)
        this.gameEnded = true;
        this.score.status = true
        return this.gameEnded
      }
      const { home, guest } = this.game;

      // Rule 1: Check if the home team is ahead in the regular innings and the guest team has 3 outs
      if (this.game.inning >= this.regularInnings) {
        if (this.offenceTeam === "home" && this.game.outs === this.maxOuts) {
          if (home.score !== guest.score) {
            this.gameEnded = true;
          }
        }
      }

      if (this.game.inning === 3) {
        // 1. Bedingung: Home führt mit mehr als 15 Punkten
        if (this.game.home.score - this.game.guest.score > 15) {
          this.gameEnded = true;
        }

        // 2. Bedingung: Nach dem dritten Out, Home liegt 15 Punkte zurück
        if (this.offenceTeam === "home" && this.game.outs >= 3 && this.game.guest.score - this.game.home.score >= 15) {
          this.gameEnded = true;
        }
      }


      if (this.game.inning === 4) {
        // 1. Bedingung: Home führt mit mehr als 15 Punkten
        if (this.game.home.score - this.game.guest.score > 10) {
          this.gameEnded = true;
        }

        // 2. Bedingung: Nach dem dritten Out, Home liegt 15 Punkte zurück
        if (this.offenceTeam === "home" && this.game.outs >= 3 && this.game.guest.score - this.game.home.score >= 10) {
          this.gameEnded = true;
        }
      }

      if(this.gameEnded) {
        this.score.endTime = this.formatDate(Date.now(), 'HH mm');
        this.score.status = 0
        this.saveStatistic()
      }
      return this.gameEnded;
    },
    restartGame() {
      // Reset game state and properties to restart the game
      this.gameEnded = false;
      localStorage.removeItem('currentgame');
      this.$router.push('/');
    },
    openModal(componentName, probs = {}) {
      this.isModalOpen = true;
      if (componentName === 'Substitut') {
        this.currentComponent = Substitut;
      } else if (componentName === 'RunnerOut') {
        this.currentComponent = RunnerOut;
      } else if (componentName === 'SpecialCase') {
        this.currentComponent = PlayerSelectionModal;
      } else if (componentName === 'PlayHistory') {
        this.currentComponent = PlayHistoryModal;
      }

      this.componentProps = probs;
    },
    closeModal() {
      this.isModalOpen = false;
      this.currentComponent = null;
      this.componentProps = {};
    },
    changeLineUpPosModal(substitut, actives) {
      let probs = {
        'substitut': substitut,
        'actives': actives
      }
      this.openModal('Substitut', probs)
    }
  },
};
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.red-dot,
.green-dot,
.lightred-dot,
.lightgreen-dot,
.blue-dot,
.yellow-dot,
.white-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  position: absolute;
}
.field-wrapper {
  position: relative;
}
.field_over {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
}
.green-dot {
  background-color: green;
}

.red-dot {
  background-color: red;
}

.lightgreen-dot {
  background-color: #6bbb6b;
}

.lightred-dot {
  background-color: #9b5f5f;
}

.blue-dot {
  background-color: blue;
}
.white-dot,
.yellow-dot {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  border: 1px #000000 solid;
}
.yellow-dot {
  background-color: yellow;
}
.white-dot {
  background-color: white;
}
.dropdown-toggle {
  position: relative;
}
.dropdown-toggle::after{
  position: absolute;
  top: 40%;
  right: 5%;
}
.inning {
  font-size: 0.8rem
}
@media (min-width: 768px) {
  .btn-md-xl {
    --bs-btn-padding-y: 0.5rem;
    --bs-btn-padding-x: 1rem;
    --bs-btn-font-size: 1.25rem;
    --bs-btn-border-radius: var(--bs-border-radius-lg);
  }
  .btn-xxl {
    --bs-btn-padding-y: 0.5rem;
    --bs-btn-padding-x: 2rem;
    --bs-btn-font-size: 2.5rem;
    --bs-btn-border-radius: var(--bs-border-radius-lg);
  }
}
</style>